import { stripLeadingZeros } from "@/utility"

// Strips leading zeros from a numeric text field as it is typed or pasted, so
// "000005" never reaches the bound value. The listener runs in the capture
// phase on the field's root element, which is ahead of Vuetify's own input
// handler -- Vuetify then reads the corrected value off the native input, and
// the field shows what was stored. Correcting the value after Vuetify emits
// isn't enough: typing "00" over "0" leaves the bound value unchanged, so the
// field would keep showing "00".
const handleInput = event => {
  const input = event.target
  if (input.tagName !== "INPUT") return

  const stripped = stripLeadingZeros(input.value)
  if (stripped !== input.value) input.value = stripped
}

export default {
  bind(el) {
    el.addEventListener("input", handleInput, true)
  },
  unbind(el) {
    el.removeEventListener("input", handleInput, true)
  },
}
